._1k6fvfa0 {
  background-image: radial-gradient(var(--oq6d072) 0.125rem, var(--oq6d070) 0.125rem);
  background-size: 2.5rem 2.5rem;
}